import { get, patch, post, remove } from '@/api/base'

const fractionsApi = {
  get: async (companyUuid, fractionUuid) => {
    const { success, data } = await get({
      path: `companies/${companyUuid}/fractions/${fractionUuid}`,
    })
    return success ? data.fraction : null
  },
  getAll: async (companyUuid, params) => {
    const { success, data } = await get({
      path: `companies/${companyUuid}/fractions`,
      params: { ...params },
    })
    return success ? data.fractions : []
  },
  create: async (companyUuid, params) => {
    return await post({
      path: `companies/${companyUuid}/fractions`,
      params: { ...params },
    })
  },
  update: async (companyUuid, params) => {
    return await patch({
      path: `companies/${companyUuid}/fractions/${params.uuid}`,
      params,
    })
  },
  validAvvNumbers: async params => {
    const response = await get({
      path: `/fractions/avv_selects/index`,
      params,
    })
    return response.success ? response.data.avv_number_hash : []
  },
  delete: async (companyUuid, fractionUuid) => {
    return await remove({
      path: `companies/${companyUuid}/fractions/${fractionUuid}`,
    })
  },
}

export default fractionsApi
